/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { StorageModule } from "@vlinder-web/storage-module-react";
import toast from "react-hot-toast";
import { ADD_TO_CART } from "../graphql/addToCart.mutation";
import { GET_ALL_CARTS } from "../graphql/getAllCarts.query";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IgetAllCartsMethods extends IPluginMethodMap {
  getAllCarts(): Promise<any>;
}

export class getAllCartsService implements IAgentPlugin {
  readonly methods: IgetAllCartsMethods;
  private exchangeRate: any = 1;

  constructor() {
    this.methods = {
      getAllCarts: this.getAllCarts.bind(this),
    };
  }

  async getAllCarts() {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_ALL_CARTS,
          variables: {},
          fetchPolicy: "network-only",
        });
        console.log(this.formatUserTable(res?.data?.getAllCarts));
        return {
          getAllCarts: res?.data?.getAllCarts,
          ultUsers: this.formatUserTable(res?.data?.getAllCarts),
        };
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private formatUserTable(data: any) {
    data;
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        const minDownPaymentSum = (item?.items ?? []).reduce(
          (sum: number, currentItem: any) => {
            const downPayment = parseFloat(
              currentItem?.costumeValue?.minDownPayment || "0"
            );
            return sum + downPayment;
          },
          0
        );

        const formattedItems = (item?.items ?? []).map((itm: any) => ({
          costumeType: itm?.costumeType?.id ?? "",
          costumeFeature: itm?.costumeFeature?.id ?? "",
          costumeAttribute: itm?.costumeAttribute?.id ?? "",
          costumeValue: itm?.costumeValue?.id ?? "",
        }));

        return {
          id: item?._id,
          sectionName: item?.section?.name ?? "Null",
          sectionOptTypeName: item?.section?.costumeTypes[0]?.name ?? "-",
          totalAmt: item?.totalAmount ?? "0",
          deleteIcon: true,
          discountedAmount: 0,
          content: item,
          minDownPayment: minDownPaymentSum,
          items: {
            presentation: item?.presentation?.id ?? "",
            section: item?.section?.id ?? "",
            items: formattedItems,
            referal: item?.referal,
            address: {
              addressLine1: item?.address?.addressLine1,
              city: item?.address?.city,
            },
            availableTime: item?.availableTime,
          },
        };
      });
    console.log("_rowData106", _rowData);
    return _rowData;
  }
}
